import { render, staticRenderFns } from "./NewPresentation.vue?vue&type=template&id=fc9ab528&"
import script from "./NewPresentation.vue?vue&type=script&lang=js&"
export * from "./NewPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports